import { useTranslation } from 'react-i18next';

export function useReasons() {
	const { t } = useTranslation();

	return [
		{
			label: t('contact.form.reasons.administrativeQuestion'),
			value: 'administrative-question'
		},
		{
			label: t('contact.form.reasons.suggestionQuestion'),
			value: 'suggestion-question'
		},
		{
			label: t('contact.form.reasons.technicalQuestion'),
			value: 'technical-question'
		},
		{
			label: t('contact.form.reasons.refundQuestion'),
			value: 'refund-question'
		},
		{
			label: t('contact.form.reasons.otherQuestion'),
			value: 'other-question'
		}
	];
}
